import React from "react";

const occupationCodes = (props) => {
  return (
    <div>
      <div className="mt-3">
        <h4 className="heading4 fw-sb text-color2">Occupation Code</h4>
        <h4 className="heading4 fw-sb">
          If you are a student, enter 08 because the sector is Education, and 7
          because the level is Student.
        </h4>
        <div className="row mb-4">
          <div className="col-md-4">
            <ul className="mb-0 list-unstyled">
              <li>
                <div className="d-flex justify-content-between">
                  <span className="fw-sb heading4">Sector</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Administrative Services</span>
                  <span>01</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Agriculture, Fishing, Forestry, Mining</span>
                  <span>02</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Arts and Entertainment</span>
                  <span>03</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Banking and Finance</span>
                  <span>04</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Catering and Leisure</span>
                  <span>05</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Construction Industries</span>
                  <span>06</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Craft and Design</span>
                  <span>07</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Education</span>
                  <span>08</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Health and Social Services</span>
                  <span>09</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Installation, Maintenance and Repair Services</span>
                  <span>10</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Law and Legal Services</span>
                  <span>11</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Manufacturing and Assembly Industries</span>
                  <span>12</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Personal Services</span>
                  <span>13</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Retail Trade</span>
                  <span>14</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Technical and Scientific</span>
                  <span>15</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Telecommunications and the Media</span>
                  <span>16</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Transport</span>
                  <span>17</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Utilities (gas, water, etc.)</span>
                  <span>18</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Wholesale Trade</span>
                  <span>19</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Other</span>
                  <span>00</span>
                </div>
              </li>
            </ul>
          </div>
          <div className="col-md-4">
            <ul className="mb-0 list-unstyled">
              <li>
                <div className="d-flex justify-content-between">
                  <span className="fw-sb heading4">Level</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Self-employed</span>
                  <span>1</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Employer/Partner</span>
                  <span>2</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Employee (Senior level)</span>
                  <span>3</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Employee (Middle or Junior level)</span>
                  <span>4</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Worker in the home</span>
                  <span>5</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Retired</span>
                  <span>6</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Student</span>
                  <span>7</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Other</span>
                  <span>0</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <h4 className="heading4 fw-sb text-color2">
          Why you are taking the test
        </h4>

        <div className="row mb-4">
          <div className="col-md-6">
            <ul className="mb-0 list-unstyled">
              <li>
                <div className="d-flex justify-content-between">
                  <span>For higher education extended course</span>
                  <span>01</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>For higher education short course</span>
                  <span>02</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>For other education purposes</span>
                  <span>03</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>For registration as a doctor</span>
                  <span>04</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>For immigration</span>
                  <span>05</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>For employment</span>
                  <span>06</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>For professional registration (NOT medical)</span>
                  <span>07</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>For personal reasons</span>
                  <span>08</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>For registration as a nurse (including CGFNS)</span>
                  <span>09</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>For registration as a dentist</span>
                  <span>10</span>
                </div>
              </li>
              <li>
                <div className="d-flex justify-content-between">
                  <span>Other</span>
                  <span>00</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default occupationCodes;
